import { IAppState } from '../../common/state';

export const selectResults = (state: IAppState) => state.results;
